import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FLAGS } from 'legacy/common/constants/launchdarkly';
import Redirect from 'legacy/components/util/Redirect/Redirect';

import AssociationApprovalWorkflowsLayout from '../layout';
import AssociationAdminTeamsCreate from 'screens/associations/AssociationAdminTeams/create';

const AssociationAdminTeamsCreateScreen = () => {
  const flags = useFlags();

  if (!flags[FLAGS.ENABLE_ASSOCIATION_WORKFLOWS]) {
    return <Redirect to="/404" />;
  }

  return <AssociationAdminTeamsCreate />;
};

export default AssociationAdminTeamsCreateScreen;

AssociationAdminTeamsCreateScreen.getLayout = (page) => (
  <AssociationApprovalWorkflowsLayout
    title="settings.teams.title"
    goBackDestination="teams"
  >
    {page}
  </AssociationApprovalWorkflowsLayout>
);
